<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Ambassades
        <span class="separator" />
      </h1>
    </b-col>
    <ListeAmbassades />
  </div>
</template>

<script>
import ListeAmbassades from "@/components/ambassades/ListeAmbassades.vue";

export default {
  name: "Ambassades",
  components: {
    ListeAmbassades,
  },
};
</script>
<style lang="scss" scoped></style>
